<template>
  <VModal
      :title="service.name ? 'ویرایش خدمات ' + service.name : 'ایجاد خدمات'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="type" :value="$route.params.type">
      <input type="hidden" name="_method" value="PUT" v-if="service.name">

      <div class="mt-5">
        <VImageInput :photo="service.photo ? service.photo.path : ''"/>
      </div>

      <fieldset class="border rounded p-4 mt-4 pt-0">
        <legend>نام خدمات</legend>

        <div v-for="lang in languages" :key="lang.id" class="mt-4">
          <label>نام {{ lang.name }}</label>
          <VInput
              type="text"
              :name="'name_' + lang.code"
              :value="$helper.getTextValue(lang, service.name_text)"
              placeholder="نام"
              class="mt-4"
              :required="lang.code === 'fa'"/>
        </div>
      </fieldset>

      <fieldset class="border rounded p-4 mt-4 pt-0">
        <legend>توضیحات خدمات</legend>

        <div v-for="lang in languages" :key="lang.id" class="mt-4">
          <label>توضیحات {{ lang.name }}</label>
          <VInput
              type="text"
              :name="'description_' + lang.code"
              :value="$helper.getTextValue(lang, service.description_text)"
              placeholder="توضیحات"
              class="mt-4"
              :required="lang.code === 'fa'"/>
        </div>
      </fieldset>

      <div class="grid grid-cols-2 gap-4 mt-5">
        <div>
          <label>دسته بندی</label>
          <select name="category_id" class="w-full bg-dark-form rounded-lg w-full mt-4 p-3 ">
            <option value="" disabled>انتخاب دسته بندی</option>
            <option v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                    :selected="service.category ? service.category.id === category.id : false">
              {{ category.name }}
            </option>
          </select>
        </div>
        <div>
          <label>نوع</label>
          <select name="type" class="w-full bg-dark-form rounded-lg w-full mt-4 p-3">
            <option value="" disabled>انتخاب نوع</option>
            <option value="housekeeping" :selected="service.type === 'housekeeping'">خانه داری</option>
            <option value="reception" :selected="service.type === 'reception'">پذیرش</option>
          </select>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 mt-5">
        <div>
          <label>محدودیت</label>
          <select name="limit_type" class="w-full bg-dark-form rounded-lg w-full mt-4 p-3" v-model="limitType">
            <option value="none">ندارد</option>
            <option value="constant">ثابت (به ازای هر اتاق)</option>
            <option value="variable">متغیر (به ازای هر نفر)</option>
          </select>
        </div>
        <div v-if="limitType !== 'none'">
          <label>مقدار محدودیت</label>
          <VInput type="number" name="limit_value" :value="service.limit_value" placeholder="مقدار محدودیت" class="mt-4" required/>
      </div>
      </div>
      <div class="mt-5">
        <label>ترتیب</label>
        <VInput type="number" name="order" :value="service.order" placeholder="ترتیب نمایش خدمات" class="mt-4" required/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت خدمات</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن خدمات، خدمات نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="service.active"/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <label>نمایش در صفحه اصلی</label>

        <VSwitch v-model="homepage" :value="service.homepage"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import VImageInput from "@/components/General/VImageInput";
import {createService, updateService} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import {mapState} from "vuex";

export default {
  name: "ModalService",
  components: {VLoadingScreen, VAlert, VImageInput, VButton, VSwitch, VInput, VModal},
  emits: ['created', 'edited'],
  props: {
    show: Boolean,
    service: {
      type: Object,
      default: () => ({})
    },
    categories: Array
  },
  data() {
    return {
      image: '',
      active: 1,
      loading: false,
      errors: [],
      limitType: this.service ? this.service.limit_type : 'none',
      homepage: 0,
    }
  },
  computed: {
    ...mapState(['user', 'languages'])
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let service = new FormData(this.$refs.form)
      service.append('active', this.active)
      service.append('homepage', this.homepage)

      if (this.service.name) {
        this.updateService(service)
      } else {
        this.createService(service)
      }
    },
    updateService(service) {
      updateService(this.service.id, service)
          .then(resp => {
            this.$emit('edited', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
    createService(service) {
      createService(service)
          .then(resp => {
            this.$emit('created', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    }
  }

}
</script>

<style scoped>

</style>